export default __webpack_public_path__ + "static/media/Group_11638.fa9d2f86.svg";